import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { AlertEnum } from "utils/horse";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  root: {},
  horseAlertDialog: {
    "& .MuiDialogTitle-root": {
      padding: 20,
      "& .MuiTypography-root": {
        lineHeight: 1
      }
    },
    "& .MuiDialogContent-root": {
      padding: 0,
      borderTop: "none"
    },
    "& .MuiDialog-paper": {
      maxWidth: 400,
      width: 400,
      margin: 0,
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        maxWidth: 340,
        width: 340
      },
      [theme.breakpoints.up("sm")]: {
        marginLeft: `calc(${theme.widthTabletDrawer}px + env(safe-area-inset-left))`
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: `calc(${theme.widthDesktopDrawer}px + env(safe-area-inset-left))`
      }
    }
  },
  horseAlertDialogMessage: {
    padding: "0 20px 10px",
    fontSize: 14,
    color: "#333333"
  },
  dialogActions: {
    padding: "8px 16px",
    justifyContent: "space-between"
  },
  leftActions: {},
  rightActions: {},
  dialogActionButton: {
    fontSize: 14,
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      fontSize: 12
    }
  },
  dialogButtonClose: {
    color: theme.palette.text.secondary,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  dialogButtonHorseDetails: {
    color: "#333333"
  },
  dialogButtonSchedule: {
    color: theme.palette.secondary.dark,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    textDecoration: "none",
    cursor: "pointer"
  },
  [AlertEnum.na]: {
    color: theme.palette.text.secondary
  },
  [AlertEnum.non]: {
    color: theme.palette.secondary.dark
  },
  [AlertEnum.middle]: {
    color: theme.palette.warning.light
  },
  [AlertEnum.moderate]: {
    color: theme.palette.warning.main
  },
  [AlertEnum.high]: {
    color: theme.palette.warning.dark
  }
}));
